export default function Reviews() {
  const reviews = [
    {
      name: 'Sarah Mitchell',
      rating: 5,
      text: 'Absolutely love the quality of products! The vitamin supplements have made such a difference in my energy levels. Fast shipping and excellent customer service.',
      avatar: 'https://public.readdy.ai/ai/img_res/af85c481ac441f068a169e2b0a517927.jpg',
      date: '2 weeks ago'
    },
    {
      name: 'Emily Rodriguez',
      rating: 5,
      text: 'The skincare products are amazing! My skin has never looked better. I especially love the vitamin C serum and the hydrating cream. Will definitely order again!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20smiling%20woman%20with%20radiant%20skin%20and%20natural%20beauty%20on%20clean%20white%20background%2C%20professional%20photography%2C%20healthy%20lifestyle%20aesthetic&width=200&height=200&seq=review002&orientation=squarish',
      date: '1 month ago'
    },
    {
      name: 'Jessica Thompson',
      rating: 5,
      text: 'Great selection of natural products! I appreciate that everything is high quality and ethically sourced. The essential oils are pure and the prices are reasonable.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20cheerful%20smiling%20woman%20with%20clear%20healthy%20skin%20on%20clean%20white%20background%2C%20professional%20photography%2C%20wellness%20and%20beauty%20aesthetic&width=200&height=200&seq=review003&orientation=squarish',
      date: '3 weeks ago'
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          Reviews
        </h2>
        <p className="text-center text-gray-600 mb-16 text-lg">
          What our customers are saying
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
                  <img 
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{review.name}</h4>
                  <div className="flex items-center mt-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                {review.text}
              </p>
              <span className="text-sm text-gray-400">{review.date}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-12 space-x-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-star-fill text-3xl text-amber-500"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900">4.9</div>
            <div className="text-sm text-gray-600">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-user-heart-line text-3xl text-emerald-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900">15K+</div>
            <div className="text-sm text-gray-600">Happy Customers</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-shopping-bag-line text-3xl text-blue-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900">25K+</div>
            <div className="text-sm text-gray-600">Orders Delivered</div>
          </div>
        </div>
      </div>
    </section>
  );
}
